<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-download', fontSet: 'fad'}"
	[headerText]="(T.EXPORT_ASSESSMENTS_DIALOG_TITLE | translate) + ' (' + data.assessmentIds.length + ')'"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<sim-scenario-archive-exports-panel [assessmentIds]="data.assessmentIds" [panelOpen]="true" />
	</ng-container>

	<ng-container actions />
</sim-basic-material-dialog>
